export const viewTypes = {
  BIG_ICON: "big_icon",
  SMALL_ICON: "small_icon",
  TABLE: "tables"
};
